// import React from "react";
// import { Navigate } from "react-router-dom";

// const Protected = ({ children }) => {

//     if (!localStorage.getItem("user") || localStorage.getItem("user") === 'null') {
//       return <Navigate to="/login"  replace={true}/>;
//     }
   
//     return children;
//   };

// export default Protected;

// src/Protected.js
import React from "react";
import { Navigate } from "react-router-dom";

const Protected = ({ children, requiredRole }) => {
  const user = localStorage.getItem("user");

  if (!user || user === 'null') {
    return <Navigate to="/login" replace={true} />;
  }

  // Vérification du rôle si spécifié
  if (requiredRole) {
    const userData = JSON.parse(user);
    if (userData.role !== requiredRole) {
      return <Navigate to="/unauthorized" replace={true} />;
    }
  }
   
  return children;
};

export default Protected;